import React, {ChangeEvent, Component, ReactNode, Fragment} from 'react';
import DefaultLayout, {DefaultLayoutProps} from 'layouts/Default';
import {Tab, Tabs} from '@material-ui/core';
import {RouteComponentProps, withRouter} from 'react-router';
import RouteURLs from 'RouteURLs';
import NextRouteURLs from 'NextRouteURLs';
import './index.scss';
import Logo from 'components/Logo';
import DashboardHeader from 'components/DashboardHeader';
import {AuthenticatedUser} from 'services/entities/auth';
import {CancellablePromise, WrappedCancellablePromise} from 'util/promises';
import {isLoggedIn, loadUser} from 'services/auth';
import UserWidget from 'components/UserWidget';

export enum DashboardTab {
  Overview,
  Bookings,
}

interface DashboardLayoutState {
  user: AuthenticatedUser|null;
}

interface DashboardLayoutProps extends RouteComponentProps, DefaultLayoutProps {
  currentTab?: DashboardTab;
  tabChildren?: ReactNode;
}

class LandlordDashboardLayout extends Component<DashboardLayoutProps, DashboardLayoutState> {
  state: DashboardLayoutState = {
    user: null
  };

  private loadProfilePromise: CancellablePromise<AuthenticatedUser>|null = null;

  componentDidMount(): void {
    if(isLoggedIn()) {
      this.loadProfilePromise = new WrappedCancellablePromise(loadUser());
      this.loadProfilePromise.then(
        user => {
          this.loadProfilePromise = null;
          this.setState({user: user});
        },
        () => {
          this.loadProfilePromise = null;
        }
      );
    }
  }

  componentWillUnmount(): void {
    if(this.loadProfilePromise != null) {
      this.loadProfilePromise.cancel();
      this.loadProfilePromise = null;
    }
  }

  private onCurrentTabChanged = (ev: ChangeEvent<{}>, value: any) => {
    const tab = value as DashboardTab;
    switch(tab) {
      case DashboardTab.Overview:
        this.props.history.push(RouteURLs.LANDLORD_DASHBOARD);
        break;
      case DashboardTab.Bookings:
        this.props.history.push(RouteURLs.LANDLORD_BOOKINGS);
        break;
    }
  };

  renderTabs(children?: ReactNode) {
    const currentTab = (this.props.currentTab as DashboardTab) || DashboardTab.Overview;
    return <div className="tabs-row">
      <div className="container">
        <a href={NextRouteURLs.HOME} className="logo-container"><Logo /></a>
        <Tabs value={currentTab} onChange={this.onCurrentTabChanged} variant="scrollable" scrollButtons="auto">
          <Tab label="Overview" value={DashboardTab.Overview} />
          <Tab label="Bookings" value={DashboardTab.Bookings} />
        </Tabs>
        { children }
      </div>
    </div>;
  }

  renderHeader() {
    const user = this.state.user;
    const navItems = [
      { title: "Dashboard", route: RouteURLs.DASHBOARD },
      { title: "Designs", route: RouteURLs.DESIGN_LIST },
    ];
    return (
      <DashboardHeader navItems={navItems}>
      { user && <UserWidget user={user}/> }
    </DashboardHeader>);
  }

  render() {
    const { children, className, ...props } = this.props;
    const fullClassName = `landlord-dashboard-layout ${className || ''}`;
    return <DefaultLayout {...props} className={fullClassName} header={this.renderHeader()}
                          footer={<Fragment />}
                          topChildren={this.renderTabs(this.props.tabChildren)}>
      { children }
    </DefaultLayout>;
  }
}

export default withRouter(LandlordDashboardLayout);